import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useProductObservations = ({ options, ...axiosConfig } = {}) => {
  const [{ data, error, loading }, getObservations] = useAxios({ url: '/product-observations', ...axiosConfig }, options);

  const [observations, setObservations] = useState([]);
  const [total, setTotal] = useState(0);
  const [size, setSize] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  useEffect(() => {
    if (data) {
      setObservations(data.data);
      setTotal(data?.meta?.total);
      setSize(data?.meta?.per_page);
      setNumberOfPages(data.meta?.last_page);
    }
  }, [data, loading, error]);

  return [{ observations, total, numberOfPages, size, error, loading }, getObservations];
};

export default useProductObservations;
